// removed by extract-text-webpack-plugin
module.exports = {"tool-bar":"_27NsV","toolBar":"_27NsV","iframe":"SYtQI","iframe-hidden":"_2PsEA","iframeHidden":"_2PsEA","title":"_2Oojr"};